import React, { useState } from 'react';
import { connect } from 'react-redux';
import DropdownList from 'react-select';
import * as actions from '../../Actions/matchables';
import TransactionDetails from './TransactionDetails';
import moment from 'moment';
import { withStyles } from '@material-ui/core/styles';
import cssClasses from './transaction.css';
import Search from '../TransactionsMenu/Search';
import DateRange from './DateRange';
import FindMatchTable from './FindMatchTable';
import { customStylesSplit200 } from '../UI/select-styles';
import { OptionBasic } from '../UI/select';

const styles = theme => ({
    root: {
      flexGrow: 1
    }
  });

let MatchTransaction = (props) => {
    const { account, onClose, clearStatus, transDetails, contacts, status, uncodeTransaction, isR1 } = props;
    const [selected, setSelected] = React.useState([]);
    const [firstSelected, setFirstSelected] = React.useState({});
    const [searchBy, setSearchBy] = useState('');
    const [transactionType, setTransactionType] = useState({value: '', label: 'All'});
    const [dateRange, setDateRange] = useState({
      transactionsFrom: moment.utc().add(-3, 'months').startOf('day'),
      transactionsTo: moment.utc().endOf('day')
    });
    const moneyOut = transDetails.Amount < 0;
    const transAmount = Math.abs(transDetails.Amount).toFixed(2);
    const selectedTotalAmount = Math.abs(selected.map(({ payment }) => payment * 1).reduce((sum, i) => sum + i, 0)).toFixed(2);
    const hasZeroPayment = selected.some(({ payment }) => payment == 0);
    const isUndepositedSelected = firstSelected && (firstSelected.type === 'SalesReceipt' || firstSelected.type === 'ReceivePayment' || firstSelected.type === 'JournalEntry');
    const isInvoiceOrBillSelected = firstSelected && (firstSelected.type === 'Invoice' || firstSelected.type === 'Bill');
    const isButtonDisabled = hasZeroPayment || (isUndepositedSelected && selectedTotalAmount !== transAmount) || (isInvoiceOrBillSelected && selectedTotalAmount !== transAmount) || (selected.length === 0) || (status && status.posting);
    const transactionTypes = moneyOut ? [{value: 'Bill', label: 'Bill'}] 
      : isR1 ? [{value: 'Invoice', label: 'Invoice'}]
      : [ {value: '', label: 'All'}, {value: 'Invoice', label: 'Invoice'}, {value: 'SalesReceipt', label: 'Sales Receipt'}, 
        {value: 'JournalEntry', label: 'Journal Entry'}, {value: 'ReceivePayment', label: 'Receive Payment'} ];

    React.useEffect(() => {
      if (status && !status.posting && status.success) {
        onClose();
        clearStatus();
      }
    }, [status])

    const saveMatch = () => {
      uncodeTransaction(transDetails);

      const paymentDetails = {
        allocation: selected.map(item => ({
          TxnId: item.txnId, 
          Amount: item.payment
        }))
      }
      if (isR1) {
        moneyOut 
          ? props.r1BillPayment(paymentDetails, transDetails.BankDataGUID, props.dateRange, account)
          : props.r1ReceivePayment(paymentDetails, transDetails.BankDataGUID, props.dateRange, account);
      } else {
        if (moneyOut) {
          props.billPayment(paymentDetails, transDetails.BankDataGUID, props.dateRange, account);
        } else {
          selected[0].type === 'Invoice' ? props.receivePayment(paymentDetails, transDetails.BankDataGUID, props.dateRange, account)
            : props.deposit(paymentDetails, transDetails.BankDataGUID, props.dateRange, account);
        }
      }
    }

    return (
    <div className={cssClasses.modal_padding}>
        <div style={{ width: 1000 }} className={cssClasses.formHorizontal}>
          <TransactionDetails modalName={'Match Transaction'} transDetails={transDetails} />
          <div className={cssClasses.newSplitContainer}>
              <div className={cssClasses.flexWrapper} >
                  <div className={cssClasses.flexContainerSm}>
                      <div className={cssClasses.padding_top_half}>Show:</div>
                      <div className={cssClasses.selectBoxSm}>
                        <div>
                            <DropdownList 
                              styles={customStylesSplit200}
                              components={{ Option: OptionBasic }}
                              menuPlacement="bottom"
                              value={transactionType}
                              onChange={setTransactionType} 
                              options={transactionTypes}
                              openMenuOnFocus />
                        </div>
                      </div>
                  </div>
                  <div className={cssClasses.divContainer}><Search onSearchchanged={setSearchBy} /></div>
                  <div className={cssClasses.divContainer}><DateRange dateRange={dateRange} setDateRange={setDateRange} /></div>
              </div>
              <div>
                  <FindMatchTable 
                    selected={selected}
                    setSelected={setSelected}
                    firstSelected={firstSelected}
                    setFirstSelected={setFirstSelected}
                    hasZeroPayment={hasZeroPayment}
                    isUndepositedSelected={isUndepositedSelected}
                    isInvoiceOrBillSelected={isInvoiceOrBillSelected}
                    isR1={isR1}
                    contacts={contacts} 
                    amount={transDetails.Amount} 
                    searchBy={searchBy} 
                    transactionType={transactionType.value}
                    dateRange={dateRange} />
              </div>
          </div>
          <div>
              <button type="button" disabled={isButtonDisabled} className={[cssClasses.btn, cssClasses.btnPrimary, cssClasses.btn_margin].join(' ')} onClick={() => saveMatch()}>Match transaction</button>
              <button type="button" className={[cssClasses.btn, cssClasses.btnSecondary].join(' ')} onClick={props.onClose}>Cancel</button>
          </div>
        </div>
    </div>
    );
};
withStyles(styles)(MatchTransaction);

function mapStateToProps(state) {
  return {
    status: state.status,
  };
}

export default connect(mapStateToProps, actions)(MatchTransaction);


// WEBPACK FOOTER //
// ./src/components/Transaction/MatchTransaction.js